import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { OnboardingService } from 'src/app/services/onboarding.service';
import { SettingsService } from 'src/app/services/settings.service';
import { SnackbarComponent } from '../snackbar/snackbar.component';

@Component({
  selector: 'app-add-other-address',
  templateUrl: './add-other-address.component.html',
  styleUrls: ['./add-other-address.component.scss']
})
export class AddOtherAddressComponent implements OnInit,OnDestroy{
  addressForm = this.fb.group({
    Id: ["", Validators.required],
    Name: ["", Validators.required],
    Addressln1: ["", Validators.required],
    Addressln2: [""],
    City: ["", Validators.required],
    State: ["", Validators.required],
    Postal: [null, Validators.required],
    Country: ["United States", Validators.required],
    CountryCode: ["US", Validators.required],
    Priority: [2],
    Isfba: [true],
    Isfbm: [false],
    Isvendor: [0],
    Picktp: [0],
    Ispicking: [1],
    Isfbmenonly: [0],
  });
  destroy$= new Subject<void>();
  states:any=[];
  constructor(
    private fb:FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<AddOtherAddressComponent>,
    private onboardingService:OnboardingService,
    private snackbar: MatSnackBar,
    private settingsService: SettingsService) { }

  ngOnInit(): void {
      const tempArray = Object.keys(this.data);
      if (tempArray.indexOf("addName") > -1) {
        tempArray.splice(tempArray.indexOf("addName"), 1);
      }
      let tempObject: any = {};
      tempArray.forEach((key, index) => {
        if (index !== -1) {
          tempObject = {
            ...tempObject,
            ...{
              [key.split("")[0].toUpperCase() +
              key.split("").slice(1).join("")]: this.data[key],
            },
          };
        }
      });
      tempObject = {
        ...tempObject,
        ...{
          Isfba: this.numberToBoolean(tempObject.Isfba),
          Isfbm: this.numberToBoolean(tempObject.Isfbm),

        },
      };
      this.addressForm.patchValue(tempObject);
    
    this.getStatesByCountryCode(this.data?.countryCode ? this.data.countryCode : "US");

    this.addressForm.get("CountryCode").valueChanges.pipe(takeUntil(this.destroy$)).subscribe(countryCode => {
      this.addressForm.controls["State"].setValue('');
      this.getStatesByCountryCode(countryCode);
    });
  }

  getStatesByCountryCode(countryCode): void {
    if (countryCode === "US") {
      this.getStates();
      this.addressForm.get("Country").setValue("United States");
    } else if (countryCode === "CA") {
      this.states = this.getProvinces();
      this.addressForm.get("Country").setValue("Canada");
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
  getStates = () => {
    this.onboardingService.getStates().pipe(takeUntil(this.destroy$)).subscribe((data: any[]) => {
      this.states = data;
    });
  };

  getProvinces = () => {
    return [
      {
        name: "Alberta",
        abbreviation: "AB",
      },
      {
        name: "British Columbia",
        abbreviation: "BC",
      },
      {
        name: "Manitoba",
        abbreviation: "MB",
      },
      {
        name: "New Brunswick",
        abbreviation: "NB",
      },
      {
        name: "Newfoundland and Labrador",
        abbreviation: "NL",
      },
      {
        name: "Northwest Territories",
        abbreviation: "NT",
      },
      {
        name: "Nova Scotia",
        abbreviation: "NS",
      },
      {
        name: "Nunavut",
        abbreviation: "NU",
      },
      {
        name: "Ontario",
        abbreviation: "ON",
      },
      {
        name: "Prince Edward Island",
        abbreviation: "PE",
      },
      {
        name: "Quebec",
        abbreviation: "QC",
      },
      {
        name: "Saskatchewan",
        abbreviation: "SK",
      },
      {
        name: "Yukon Territory",
        abbreviation: "YT",
      },
    ];
  }
 
  public addOtherAddress(){
    const tempData = this.addressForm.value;
    const formData = {
      ...tempData,
      ...{
        Isfba: this.booleanToNumber(tempData.Isfba),
        Isfbm: this.booleanToNumber(tempData.Isfbm),
      },
         };
    this.settingsService
      .UpdateWh(formData)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.dialogRef.close(true);
        this.snackbar.openFromComponent(SnackbarComponent,
            {
              duration: 3000,
              horizontalPosition: 'center',
              data: {
                title: 'Address Updated',
                action: 'Dismiss',
                type: 'success',
              },
            }
        );
      });
  } 

  dialogAction(e) {
    if (e === "Save") {
      this.addOtherAddress();
    } else if (e === "Update") {
     
    } else {
      this.close();
    }
  }
  close() {
    this.dialogRef.close();
  }

  public booleanToNumber = (data) => (data === false ? 0 : 1);

  
  public numberToBoolean = (data) => (data === 0 ? false : true);
}
